import React from 'react';

import './style.less';

function widget_privacy_policy() {
  return (
    <div className='tfs_privacy-policy'>
      <h1>Privacy Policy</h1>
      <div className='tfs_privacy-policy-body'>
        <p>Je privacy is belangrijk voor ons.</p>
        <p>
          Daarom verwerken we alle persoonsgegevens die wij van je verkrijgen
          als klant of als bezoeker van één van onze websites alleen op een
          manier die in overeenstemming is met de toepasselijke regelgeving
          inzake gegevensbescherming, in het bijzonder de Algemene Verordening
          Gegevensbescherming 2016/679 van 27 april 2016 ("GDPR").
        </p>
        <p>
          Deze privacy policy bezorgt je meer informatie over welke
          persoonsgegevens we verwerken, waarom we ze verwerken, hoe we deze
          verkrijgen, hoe lang we deze bijhouden en met wie we ze delen.
        </p>
        <h2>1. IDENTITEIT EN CONTACTGEGEVENS</h2>
        <p>
          De gezamenlijke verwerkingsverantwoordelijken voor je persoonsgegevens
          zijn de volgende juridische entiteit en een aantal
          dochterondernemingen van deze juridische entiteit:
        </p>
        <ul>
          <li>The Fashion Society NV</li>
          <li>Brusselsesteenweg 185</li>
          <li>1785 Merchtem</li>
          <li>België</li>
          <li>Ondernemingsnummer 0553.548.910</li>
        </ul>
        <p>
          De winkels van deze entiteiten zijn gekend onder de commerciële
          benamingen ZEB, Pointcarré, The Fashion Store, Ziffiks en Zeb For
          Stars.
        </p>
        <p>
          In geval je vragen hebt over de verwerking van jouw persoonsgegevens,
          neem dan zeker contact op met onze customer service. Zij helpen je
          heel graag verder. Je kan hen bereiken via één van de volgende
          kanalen:
        </p>
        <ul>
          <li>• Via e-mail: privacy@thefashionsociety.com</li>
          <li>• Via telefoon: 02/568.11.85</li>
          <li>• Via de live chat op de webshops van ZEB en Pointcarré</li>
        </ul>
        <h2>
          <b>2.DOELEINDEN</b>
        </h2>
        <p>
          Wij verwerken je persoonsgegevens voor één of meer van de volgende
          doeleinden:
        </p>
        <ul>
          <li>• Klantenbeheer</li>
          <li>• Direct marketing</li>
          <li>• Optimalisatie van de website</li>
          <li>• Camerabewaking</li>
        </ul>
        <p>
          Hieronder kan je per doeleinde terugvinden welke persoonsgegevens we
          verwerken, waarom we ze verwerken, hoe we deze verkrijgen, hoe lang we
          deze bijhouden en met wie we ze delen.
        </p>
        <h3>
          <b>2.1. Klantenbeheer</b>
        </h3>
        <p>
          In het kader van ons klantenbeheer verwerken wij je
          identificatiegegevens (naam, titel, facturatieadres, leveradres,
          telefoonnummer, e-mailadres, klantennummer), een aantal financiële
          gegevens (betaalmethode, bankrekeningnummer) en houden wij je
          aankoopgeschiedenis en je eventuele afspraken, berichten of vragen aan
          ons bij.
        </p>
        <p>
          Deze gegevens laten ons toe om jouw bestellingen of aankopen en
          afspraken op een correcte manier af te handelen en op een vlotte
          manier met jou te communiceren en je vragen te beantwoorden. Ook bij
          eventuele retours kunnen we je zo beter verder helpen. Als je lid bent
          van ons loyalty programma en wil genieten van de voordelen hiervan,
          hebben we jouw gegevens nodig om de punten op jouw account te zetten.
          Na een aankoop kunnen wij je ook contacteren om te peilen naar je
          tevredenheid. Wanneer je hebt deelgenomen aan een van onze
          wedstrijden, kunnen wij je op die manier contacteren.
        </p>
        <p>
          De rechtsgrond voor deze verwerking is de uitvoering van een
          overeenkomst waarbij je partij bent of om eventuele vragen te
          beantwoorden voorafgaand aan het aangaan van een overeenkomst (art. 6,
          §1, (b) GDPR).
        </p>
        <p>
          Wij verkrijgen deze persoonsgegevens rechtstreeks van jou, bijv. door
          het inlezen van je elektronische identiteitskaart in een winkel of
          wanneer je een account aanmaakt op één van onze websites.
        </p>
        <p>
          Voor ons klantenbeheer houden wij je persoonsgegevens bij tot 10 jaar
          na je laatste aankoop.
        </p>
        <p>
          Wij delen deze persoonsgegevens uitsluitend met derde partijen met wie
          wij samenwerken in het kader van ons klantenbeheer (IT en
          softwareproviders en de koerierdienst).
        </p>
        <h3>
          <b>2.2. Direct marketing</b>
        </h3>
        <p>
          Voor direct marketing verwerken wij je identificatiegegevens (naam,
          titel, adres, telefoonnummer, e-mailadres, IP-adres, cookies), een
          aantal persoonlijke kenmerken (geslacht, geboortedatum, moedertaal),
          je aankoopgeschiedenis en browsegeschiedenis. Op de website van Zeb
          For Stars kan je ook de identificatiegegevens (naam) en persoonlijke
          kenmerken (geslacht, geboortedatum) van je kind(eren) ingeven. Als je
          ons tagt in één van je Instagram foto's, kunnen wij ook je afbeelding
          verwerken.
        </p>
        <p>
          Deze gegevens laten ons toe om je communicaties te versturen en
          daarvoor het gepaste medium te kiezen: d.i. per e-mail, post, SMS,
          telefoon en/of via online advertenties. Op die manier kunnen we je
          onder meer op de hoogte houden van onze aanbiedingen en de laatste
          trends of nieuwigheden. We sturen je dan een attentie op je verjaardag
          en kunnen je uitnodigen voor onze events. Indien je hiermee hebt
          ingestemd op de website van Zeb For Stars, bezorgen wij ook je
          kind(eren) een attentie op hun verjaardag.
        </p>
        <p>
          Wij gebruiken je gegevens ook om onze communicaties te personaliseren
          (bijv. op basis van je geslacht, woonplaats of vaak gekochte merken).
          Op die manier kunnen we je tips bezorgen die helemaal op jouw maat
          gemaakt zijn.
        </p>
        <p>
          Instagram foto's waarin je ons tagt kunnen we hergebruiken op onze
          websites en sociale media en in onze winkels en communicaties.
        </p>
        <p>
          De rechtsgrond voor deze verwerking is het gerechtvaardigd belang om
          onze producten en diensten te promoten bij onze klanten (art. 6, §1,
          (b) GDPR). Indien je geen klant bent, ontvang je onze communicaties
          alleen wanneer je hiervoor je toestemming hebt gegeven, bijv. door je
          in te schrijven op een nieuwsbrief via één van onze websites (art. 6,
          §1, (a) GDPR). Wij zullen je kind(eren) enkel een verjaardagsattentie
          sturen indien je hiervoor je toestemming hebt gegeven op de website
          van Zeb For Stars. Online advertenties zijn enkel te zien wanneer je
          toestemming hebt gegeven voor het plaatsen van advertentiecookies
          (voor meer informatie, zie Cookieverklaring ZEB, Pointcarré, ZEB For
          Stars, The Fashion Store).
        </p>
        <p>Wij verkrijgen deze persoonsgegevens steeds rechtstreeks van jou.</p>
        <p>
          Wij versturen communicaties tot 6 jaar na je laatste aankoop. Je kan
          je uiteraard steeds vroeger uitschrijven (voor meer informatie, zie
          Rechten). De toestemming voor advertentiecookies kan ook steeds
          ingetrokken worden via je cookievoorkeuren (voor meer informatie, zie
          Cookieverklaring ZEB, Pointcarré, ZEB For Stars, The Fashion Store).
          Wij hergebruiken Instagram foto's waarin je ons getagd hebt enkel
          indien je hiervoor specifiek je toestemming hebt gegeven via
          Instagram.
        </p>
        <p>
          Wij delen deze persoonsgegevens uitsluitend met derde partijen met wie
          wij samenwerken voor direct marketing (IT en softwareproviders en
          aanbieders van marketingtools).
        </p>
        <h3>
          <b>2.3.Optimalisatie van de websites</b>
        </h3>
        <p>
          Voor de optimalisatie van onze websites verwerken wij je
          identificatiegegevens (IP-adres en cookies).
        </p>
        <p>
          Deze gegevens laten ons toe om een goed functionerende en
          gebruiksvriendelijke website en desgevallend webshop aan te bieden.
        </p>
        <p>
          De rechtsgrond voor het plaatsen van technisch essentiële en
          functionele cookies is een gerechtvaardigd belang om een goed
          functionerende en gebruiksvriendelijke website en webshop te kunnen
          aanbieden (art. 6, §1, (f) GDPR). Analytische cookies en sociale
          mediacookies worden enkel geplaatst wanneer je via de betrokken
          website je toestemming hebt gegeven voor het plaatsen van deze cookies
          (art. 6, §1, (a) GDPR) (voor meer informatie, zie Cookieverklaring
          ZEB, Pointcarré, ZEB For Stars, The Fashion Store).
        </p>
        <p>Wij verkrijgen deze persoonsgegevens steeds rechtstreeks van jou.</p>
        <p>
          De vervaltermijn verschilt per cookie en je kan je cookievoorkeuren
          steeds wijzigen (voor meer informatie, zie Cookieverklaring ZEB,
          Pointcarré, ZEB For Stars, The Fashion Store).
        </p>
        <p>
          Wij delen deze persoonsgegevens uitsluitend met derde partijen met wie
          wij samenwerken voor de betrokken website en webshop (IT en
          softwareproviders).
        </p>
        <h3>
          <b>2.4.Camerabewaking</b>
        </h3>
        <p>
          Al onze winkels zijn voorzien van camerabewaking. Wanneer je bij ons
          komt winkelen, worden er dus beelden van je geregistreerd evenals de
          locatie, de datum en het uur van registratie.
        </p>
        <p>
          De camerabewaking heeft uitsluitend tot doel om de veiligheid in onze
          winkels te garanderen, om diefstallen te vermijden n om misdrijven,
          conflicten, schadegevallen en andere ongevallen af te handelen.
        </p>
        <p>
          De camerabewaking wordt duidelijk aangegeven in de winkels met het
          gekende pictogram. Wanneer je bij ons komt winkelen, word je geacht te
          hebben toegestemd met de registratie van je beelden.
        </p>
        <p>
          De beelden worden maximum 30 dagen bijgehouden, behoudens wanneer wij
          deze langer nodig hebben als bewijs van een misdrijf of overlast.
        </p>
        <p>
          Wij delen deze beelden enkel met derde partijen met wie we samenwerken
          in het bereiken van de hierboven vermelde doeleinden (bijv.
          veiligheidsadviseurs) en indien nodig met de politiediensten en
          gerechtelijke overheden. In geval van een schadegeval kunnen de
          beelden ook worden doorgegeven aan onze verzekeraar, advocaat, experts
          of andere betrokken partijen.
        </p>
        <h2>
          <b>3. BEVEILIGING</b>
        </h2>
        <p>
          We hebben passende technische en organisatorische maatregelen
          geïmplementeerd om de vertrouwelijkheid van je persoonsgegevens te
          waarborgen en je gegevens te beschermen tegen onopzettelijke of
          onwettige vernietiging, verlies, wijziging, ongeautoriseerde
          openbaarmaking of toegang.
        </p>
        <p>
          Wij hebben de nodige contractuele afspraken gemaakt met de derde
          partijen met wie wij samenwerken en geven je persoonsgegevens niet
          door buiten de Europese Economische Ruimte zonder de garantie dat je
          gegevens daar ook een evenwaardig beschermingsniveau genieten.
        </p>
        <h2>
          <b>4. RECHTEN</b>
        </h2>
        <p>
          Je kan onze customer service altijd contacteren voor de uitoefening
          van de volgende rechten:
        </p>
        <ul>
          <li>
            een verzoek om toegang of rectificatie van je persoonsgegevens
          </li>
          <li>een verzoek om wissing van je persoonsgegevens</li>
          <li>
            een verzoek om beperking van de verwerking van je persoonsgegevens
          </li>
          <li>een bezwaar tegen de verwerking van je gegevens</li>
          <li>
            een klacht als je van mening bent dat we niet handelen in
            overeenstemming met de toepasselijke regelgeving inzake
            gegevensbescherming. Je kan ook een klacht indienen bij de
            toezichthoudende autoriteit.
          </li>
        </ul>
        <p>
          Onze Customer Service stelt alles in het werk om jou meteen verder te
          helpen. Je kan hen bereiken via één van de volgende kanalen:
        </p>
        <ul>
          <li>via e-mail: privacy@thefashionsociety.com</li>
          <li>via telefoon: 02/568.11.85</li>
          <li>via de live chat op de webshops van ZEB en Pointcarré</li>
        </ul>
        <p>
          Indien je niet langer onze elektronische nieuwsbrieven wenst te
          ontvangen en de verwerking van je gegevens voor die doeleinde wil
          stopzetten, kan je ook steeds gebruik maken van de uitschrijflink
          voorzien onderaan elke nieuwsbrief.
        </p>
        <p>
          Indien je niet langer onze SMS boodschappen wenst te ontvangen en de
          verwerking van je gegevens voor die doeleinde wil stopzetten, kan je
          ook steeds reageren per SMS dat je deze niet langer wil ontvangen.
          Indien je niet langer gecontacteerd wil worden per telefoon, kan je
          dit uiteraard ook telefonisch meedelen.
        </p>
        <p>
          Voor die doeleinden waarvoor de rechtsgrond voor de verwerking van
          persoonsgegevens een gerechtvaardigd belang is, kan je ons steeds meer
          informatie vragen over de belangenafweging die wij in dat kader hebben
          uitgevoerd (voor meer informatie, zie Doeleinden).
        </p>
        <p>
          Wij respecteren alle rechten met betrekking tot je persoonsgegevens
          waarop je volgens de toepasselijke regelgeving recht hebt.
        </p>
        <p>
          Voor identificatiedoeleinden is het mogelijk dat we je om een kopie
          van de voorkant van je identiteitskaart vragen.
        </p>
        <h2>
          <b>5. UPDATES</b>
        </h2>
        <p>
          Deze privacyverklaring kan van tijd tot tijd worden gewijzigd, binnen
          de beperkingen van de toepasselijke regelgeving inzake
          gegevensbescherming. Via de QR-code en fysieke kopieën in de winkels
          en via onze websites heb je steeds toegang tot de meest actuele
          versie.
        </p>
      </div>
    </div>
  );
}

export default widget_privacy_policy;



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets/widget_privacy_policy/index.js